export default "/_next/static/6b35e175926ebc5ab49d71e756230834.jpg";